import _groupBy from 'lodash/groupBy'
import _sample from 'lodash/sample'
import _find from 'lodash/find'
import _shuffle from 'lodash/shuffle'
import { lenTypes } from '@/hooks/enums'
import { model } from '@/constants/state'

export const groupBy = _groupBy
export const sample = _sample
export const find = _find
export const shuffle = _shuffle

export const toArray = (obj: AnyObject, modifyKey = 'key') => {
  return Object.keys(obj).map(key => ({ ...obj[key], [modifyKey]: key }))
}

export const addWhen = (condition, element) => {
  return condition ? [element] : []
}

const mappingType = {
  normal: `${[lenTypes.ORDINARY]}_normal`,
  gradient: `${[lenTypes.ORDINARY]}_gradient`,
  function: `${[lenTypes.FUNCTION]}_normal`,
  function_normal: `${[lenTypes.FUNCTION]}_normal`,
  function_gradient: `${[lenTypes.FUNCTION]}_gradient`,
}

const computeLenFiltered = (len: LensColorType) => {
  const keys = len.value.split('_')
  const match = ['normal', 'gradient', 'function']
  const key = keys.filter((key) => {
    return match.some(item => item.includes(key))
  }).join('_')

  const filtered = mappingType[key] ?? mappingType.normal

  return { filtered, label: len.uiLabel }
}

export const transformModel = (item: ModelNameType) => {
  const defaultThumbnail = 'https://cdn-icons-png.flaticon.com/512/149/149456.png'

  const isOnSale = Object.keys(model.onSales).includes(item.value)
  const isOnDev = Object.keys(model.onDev).includes(item.value)
  const isForChild = Object.keys(model.forChild).includes(item.value)
  const sorter = (model.onSales[item.value] ?? model.onDev[item.value]) ?? 0
  // TODO remove frame or rimless text
  const sliceName = item.value.split('_').slice(1).join('_')
  return {
    ...item,
    url: item.uiThumbnail || defaultThumbnail,
    isOnSale,
    isOnDev,
    isForChild,
    sorter,
    gtmKey: `model_${sliceName}_button`,
  }
}

export const transformFrame = (item: FrameColorType) => {
  const labelTransformed = item?.uiLabel?.replaceAll('\\n', '<br/>') ?? ''
  return {
    ...item,
    label: labelTransformed,
    renderColor: item.uiColor,
    gtmKey: `frame_color_${item.value}_button`,
  }
}

export const transformTemple = (item: TempleColorType) => {
  return {
    ...item,
    label: item.uiLabel,
    // ? Make render gradient color from bottom to top
    renderColor: item.uiColor?.replaceAll('180deg', '-90deg'),
    gtmKey: `temple_color_${item.value}_button`,
  }
}

export const transformLensColor = (item: LensColorType) => {
  // const rgba = item.color ? colors.changeAlpha(item.color, +item.transparent) : ''
  const { filtered } = computeLenFiltered(item)
  const labelTransformed = item?.uiLabel?.replaceAll('\\n', '<br/>') ?? ''
  // const groupName =

  return {
    ...item,
    filtered,
    label: labelTransformed,
    renderColor: item.uiColor,
    gtmKey: `lens_color_${item.value}_button`,
  }
}

export const transformLensOption = (item: LensOptionType) => {
  return {
    ...item,
    gtmKey: `lens_option_${item.key}_button`,
  }
}
